import React, {ReactNode, Suspense} from 'react';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {createPortal} from 'react-dom';
import useGetFooter from '@src/Hooks/useGetFooter';

const DefaultHeader = React.lazy(() => import('./DefaultHeader/DefaultHeader'));
const PageFooter = React.lazy(
  () => import('@src/components/general/PageFooter/PageFooter'),
);

interface IDefaultLayoutProps {
  children: ReactNode;
  contentOnly?: boolean;
}

const DefaultLayout: React.FC<IDefaultLayoutProps> = props => {
  const {children, contentOnly} = props;
  const footerData = useGetFooter();

  return (
    <div
      className="default-layout"
      style={{
        maxWidth: 1920,
        margin: '0 auto',
      }}>
      <Suspense>
        <DefaultHeader style={contentOnly ? {display: 'none'} : {}} />
      </Suspense>
      <main>{children}</main>
      {!contentOnly && (
        <Suspense>
          <PageFooter {...footerData} />
        </Suspense>
      )}
      {createPortal(
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          style={{zIndex: 99999}}
        />,
        document.body,
        'default-tostify-container',
      )}
    </div>
  );
};

export default DefaultLayout;
